import { Ecommerce, EventNamesList, Taxonomy } from 'shared/tracking/contracts';
import { mapTracking } from './mapTracking';

export const trackEvent = (
    eventName: EventNamesList,
    taxonomy: Taxonomy,
    ecommerce?: Ecommerce
) => {
    const eventData = mapTracking(taxonomy, ecommerce);

    if (!eventData) return;

    window.analytics?.track(eventName, eventData);
};
